import { number } from '@/shared/libs/yup';
import { HookFormField, FieldInputProps } from '@/shared/libs/hook-form';

export const numberSchema = number().label('Number');

export const NumberHookFormField = (props: FieldInputProps) => <HookFormField.Input label="Number" {...props}/>;